<template>
  <div
    class="products-redesign-skeleton"
    aria-busy="true"
    aria-live="polite"
    aria-label="Cargando productos"
  >
    <div class="products-redesign-skeleton__pagination" aria-hidden="true">
      <span
        v-for="n in paginationDots"
        :key="'page-' + n"
        class="products-redesign-skeleton__page-dot"
      />
    </div>
    <div class="row">
      <div
        class="col-sm-6 col-md-4 col-lg-4"
        v-for="n in cardCount"
        :key="'card-' + n"
      >
        <div class="products-redesign-skeleton__card">
          <div class="products-redesign-skeleton__image" />
          <div class="products-redesign-skeleton__body">
            <div class="products-redesign-skeleton__line products-redesign-skeleton__line--title" />
            <div class="products-redesign-skeleton__line products-redesign-skeleton__line--title-short" />
            <div class="products-redesign-skeleton__stars" />
            <div class="products-redesign-skeleton__line products-redesign-skeleton__line--price-old" />
            <div class="products-redesign-skeleton__line products-redesign-skeleton__line--price" />
            <div class="products-redesign-skeleton__button" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsRedesignSkeleton',
  props: {
    cardCount: { type: Number, default: 9 },
    paginationDots: { type: Number, default: 5 },
  },
};
</script>

<style lang="scss" src="./ProductsRedesignSkeleton.scss"></style>
